import React from "react";
import BreadCrumb from "common/breadcrumb";
import Plans from "./plans";
import HorizontalPricing from "./horizontal-pricing";

const Pricing = () => {
    return (
        <React.Fragment>
            <BreadCrumb title='Pricing' pageTitle='Pages' />
            <Plans />
            <HorizontalPricing />
        </React.Fragment>
    );
}

export default Pricing;